import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=3a2cb23c&"
import script from "./Tour.vue?vue&type=script&setup=true&lang=js&"
export * from "./Tour.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Tour.vue?vue&type=style&index=0&id=3a2cb23c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports